export class InvalidArgumentsException extends Error {
  constructor() {
    super('Invalid arguments provided');
  }
}
